<script>
  export let property;

  $: propData = getPropData(property);

  async function getPropData(prop) {
    const propData = await prop;
    return {
      name: propData.locations.item.name,
      address: propData.locations.item.address
    };
  }
</script>

<header>
  {#await propData}
    <h1>Loading…</h1>
  {:then {name, address}}
    <h1>{name}</h1>
    <h2>
      <address>
        <span class="street">{address.street}</span>
        <span class="city">{address.city}</span>
        <span class="state">{address.state}</span>
        <span class="postal">{address.postal}</span>
      </address>
    </h2>
  {:catch err}
    {#if err.status === 404}
      <h1>Property not found</h1>
    {:else if err.status === 401}
      <h1>Unauthorized</h1>
      <p>Sorry, you're not authorized to view this property</p>
    {:else}
      <h1>Unexpected error!</h1>
    {/if}
  {/await}
</header>
